<template>
    <div>

        <!-- Ec breadcrumb start -->
        <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row ec_breadcrumb_inner">
                            <div class="col-md-6 col-sm-12">
                                <h2 class="ec-breadcrumb-title">{{ $t('Edit My Information') }}</h2>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <!-- ec-breadcrumb-list start -->
                                <ul class="ec-breadcrumb-list">
                                    <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                    <li class="ec-breadcrumb-item active">{{ $t('Edit My Information') }}</li>
                                </ul>
                                <!-- ec-breadcrumb-list end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ec breadcrumb end -->

        <!-- Ec login page -->
        <section class="ec-page-content section-space-p">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="section-title">
                            <h2 class="ec-title">{{ $t('Edit My Information')}}</h2>
                        </div>
                    </div>
                    <div class="ec-login-wrapper">
                        <div class="ec-login-container">

                            <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" :class="{ 'show' : error !== null }" role="alert">
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                <strong>{{error}}</strong>
                            </div>

                            <div class="ec-login-form">
                                <form  @submit.prevent="create">

                                    <span class="ec-login-wrap">
                                        <label for="login-name">{{ $t('Name') }}</label>
                                        <input type="text" class="form-control" id="login-name"
                                               aria-label="name" aria-describedby="name" v-model="item.name" required>

                                    </span>

<!--                                    <span class="ec-login-wrap">-->
<!--                                        <label for="login-mobile">{{ $t('Phone number') }}</label>-->
<!--                                        <input type="tel" class="form-control" id="login-mobile" placeholder="5×××××"-->
<!--                                               aria-label="phone" aria-describedby="phone" v-model="item.mobile" dir="ltr" required>-->
<!--                                    </span>-->

                                    <span class="ec-login-wrap">
                                        <label for="login-email">{{ $t('Email') }}</label>
                                        <input type="email" class="form-control pe-1" id="login-email"
                                               aria-label="email" aria-describedby="email" v-model="item.email" required>
                                    </span>


                                    <span class="ec-login-wrap ec-login-btn">
                                        <button class="btn btn-primary" type="submit">
                                            {{ $t('Save') }}
                                        </button>
                                    </span>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>



<script setup>
import { ref } from 'vue'
import { Head, useHead } from "@vueuse/head"
const count = ref(0)
useHead({
    title: 'تغيير كلمة المرور',
})
</script>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();

import Utility from '../../utility'
import {Bootstrap5Pagination} from "laravel-vue-pagination";

export default {
    inject: ['auth'],
    components: {
        Bootstrap5Pagination,
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if (newVal === false) {
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
    },
    data() {
        return {
            show_old_password: false,
            show_password: false,
            show_confirmPassword: false,
            error: null,
            item: {},
            validationErrors: null,
        }
    },
    created(){

        // if(this.auth.isLoggedIn() === false){
        //     this.$router.push({name: 'home'});
        // }

        this.item = this.auth.user();

    },
    methods: {
        isInvalid( name ) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {
            const id = toast.info(this.$t('sending ...'),{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });
            formData.append('_method', 'PUT');


            axios.post('auth/edit_account',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });


                that.error = null;

                this.$router.push({name: 'home', params: { lang : this.$i18n.locale } });

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.error = error.response.data.message;
                    that.validationErrors = error.response.data.errors ;
                }
            });

        },
    }
}
</script>
